import { render, staticRenderFns } from "./edit-user.vue?vue&type=template&id=fa6af49c"
import script from "./edit-user.vue?vue&type=script&lang=js"
export * from "./edit-user.vue?vue&type=script&lang=js"
import style0 from "./edit-user.vue?vue&type=style&index=0&id=fa6af49c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports